import { render, staticRenderFns } from "./fieldData.vue?vue&type=template&id=c0fabd80"
import script from "./fieldData.vue?vue&type=script&lang=js"
export * from "./fieldData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports